import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';
import './style.scss';

function HomePageMediaWraper({
   children,
   type,
   onNextContent,
}){
   const [scrollLeft, setScrollLeft] = useState(0)
   const [hiddenButtons, setHiddenButtons] = useState(true)
   useEffect(() => {
      const timer =  setTimeout(() => {
         const container = document.querySelector(`.homepage-${ type }-content`)
         if(container) {
            let value = container.scrollWidth
            setHiddenButtons(value < window.innerWidth)
         }
      }, 10);
      return () => clearTimeout(timer)
   }, [hiddenButtons, type]);

   function handleClick(direction){
      const container = document.querySelector(`.homepage-${ type }-content`)
      sideScroll(container, direction, 80, 100, 250);
   }
   function sideScroll(element, direction, speed, distance, step){
      let scrollAmount = 0;
      let left = element.scrollLeft
      var slideTimer = setInterval(function(){
         if(direction === 'left'){
            left -= step;
            setScrollLeft(left)
         } else {
            left += step;
            setScrollLeft(left)
         }
         element.scrollTo(left, 0)
         scrollAmount += step;
         if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
         }
      }, speed);

   }
   const element = document.querySelector(`.homepage-${ type }-content`)
   let scrollEnd = 0
   if(element) {
      scrollEnd = element.scrollWidth - element.getBoundingClientRect().width
   }
   const onScroll = (e) => {
      const { scrollWidth, scrollLeft, clientWidth } = e.target
      if(((scrollWidth - scrollLeft) - clientWidth < 20)) {
         onNextContent()
      }
   }

   return (
      <div className='relative h-auto flex homepage-media min-w-full'>
         {
            !hiddenButtons && scrollLeft > 0 && (
               <div
                  className='absolute left-0 z-[14] ml-3 w-20 h-20 scroll-button rounded-full'>
                  <Button
                     classNames='w-full h-full'
                     padding='none'
                     borderRadius='full'
                     backgroundColor='transparent'
                     fontIconColor='major-dark'
                     fontIconSize='tripleLarge'
                     iconName='arrow-left'
                     onClick={ () => handleClick('left') }
                  />
               </div>
            )
         }
         <div
            onScroll={ onScroll }
            className={ `flex items-center homepage-media-content homepage-${ type }-content w-full gap-4 px-6` }>
            {children}
         </div>
         {
            (!hiddenButtons && ((scrollLeft !== scrollEnd && scrollLeft < scrollEnd) || scrollLeft === 0)) && (
               <div
                  className='absolute right-0 z-[14] mr-3  w-20 h-20 scroll-button rounded-full'>
                  <Button
                     classNames='w-full h-full'
                     padding='none'
                     borderRadius='full'
                     fontIconColor='major-dark'
                     fontIconSize='tripleLarge'
                     backgroundColor='transparent'
                     iconName='arrow-right'
                     onClick={ () => handleClick('right') }
                  />
               </div>
            )
         }
      </div>
   )
}

HomePageMediaWraper.propTypes = {
   children: PropTypes.any,
   type: PropTypes.string,
   onNextContent: PropTypes.func,
}
HomePageMediaWraper.defaultProps = {
}

export default HomePageMediaWraper;
